export default "__VITE_ASSET__yu6gpnss__"